module.exports = __webpack_public_path__ + "static/media/categoryBG.1807d1d5.png";